import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { withAuth } from "../lib/AuthProvider";
import logo from '../logo.svg';

class Navbar extends Component {

  render() {
    const { logout, isLoggedin, user } = this.props;
    const isAdmin = user?.role === "admin";
    return (
      <div >
        {isLoggedin ? (
          <>
          <nav className="Nav">
            {isAdmin && (
              <div className="nav-links">
                <NavLink to="/sales" activeClassName="active">Ventas</NavLink>
                <NavLink to="/status" activeClassName="active">Status</NavLink>
                <NavLink to="/dash" activeClassName="active">Dashboard</NavLink>
                <NavLink to="/reviewppto" activeClassName="active">Review Ppto</NavLink>
                <NavLink to="/review87" activeClassName="active">Actualizar Panel</NavLink>
                <NavLink to="/admin/ppto" activeClassName="active">Cargar Ppto</NavLink>
                <NavLink to="/admin/users" activeClassName="active">Alta usuario</NavLink>
              </div>
            )}
          </nav>
          </>
        ) : (
          <>
          </>
        )}
      </div>
    );
  }
}

export default withAuth(Navbar);